export default {
  AHEAD: 'Ahead',
  BEHIND: 'Behind',
  ON_SCHEDULE: 'On Schedule',
}
